import * as React from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, type = 'text', invalid, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type}
      data-invalid={invalid || undefined}
      className={cn(
        'flex h-10 w-full rounded-md border bg-surface px-3 py-2 text-sm shadow-sm transition-colors',
        'border-line-strong text-foreground placeholder:text-muted-foreground',
        'focus-visible:outline-none focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/40',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'data-[invalid=true]:border-destructive data-[invalid=true]:focus-visible:ring-destructive/30',
        'file:border-0 file:bg-transparent file:text-sm file:font-medium',
        className,
      )}
      {...rest}
    />
  );
});
